import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'fast-text-encoding';
import React from 'react';
import ReactDOM from 'react-dom';
//import {createRoot} from 'react-dom/client';
import './index.css';
import App from 'ccm/App';
import * as serviceWorker from './serviceWorker';

/*
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
*/
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
